module.exports = __webpack_public_path__ + "media/images/equalizer-8db8e72d6bff15cfd4cf522827a32682.svg";